import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "container mt-4 mb-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://fontmeme.com/permalink/220303/53e6f4184809d9dbe6e98062a0948a4e.png",
    alt: "vue-pokedex",
    style: {"width":"20rem"}
  })
], -1)
const _hoisted_2 = { class: "container d-flex flex-column min-vh-100" }
const _hoisted_3 = { class: "row d-flex justify-content-center" }
const _hoisted_4 = { class: "row d-flex justify-content-center mt-5" }
const _hoisted_5 = { class: "row d-flex justify-content-center mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarComponent = _resolveComponent("NavbarComponent")!
  const _component_SearchBarComponent = _resolveComponent("SearchBarComponent")!
  const _component_PokemonCards = _resolveComponent("PokemonCards")!
  const _component_AlertComponent = _resolveComponent("AlertComponent")!
  const _component_SpinnerComponent = _resolveComponent("SpinnerComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavbarComponent),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SearchBarComponent, {
          onSearchPokemon: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchPokemon($event)))
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.searchingPokemon)
          ? (_openBlock(), _createBlock(_component_PokemonCards, {
              key: 0,
              pokemons: _ctx.resultPokemon
            }, null, 8, ["pokemons"]))
          : (_openBlock(), _createBlock(_component_PokemonCards, {
              key: 1,
              pokemons: _ctx.pokemons
            }, null, 8, ["pokemons"]))
      ]),
      _createElementVNode("div", _hoisted_5, [
        ((_ctx.resultPokemon.length===0&&_ctx.searchingPokemon&&!_ctx.loadingPokemon))
          ? (_openBlock(), _createBlock(_component_AlertComponent, {
              key: 0,
              type: "light",
              msg: "no results found"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.loadingPokemon)
      ? (_openBlock(), _createBlock(_component_SpinnerComponent, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.allPokemonsLoaded||(_ctx.searchingPokemon&&!_ctx.loadingPokemon))
      ? (_openBlock(), _createBlock(_component_FooterComponent, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}